import { c as _c } from "react/compiler-runtime";
// Signed-in shell (Decision booklet-layout, POC layout): the nav, then the lists the URL's route matched (router.tsx,
// nested = the pages after it), then the task detail. Forms and details are modals in ?params (layouts/modals.tsx,
// rendered by components/panel.tsx): the one Sheet on phones; on desktop a page after the page each belongs to (the
// routes place them with <After />, from AfterContext here), the nav's (scope, filter) and the end's (?id) here.
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router";
import { api, type TaskStatus } from "@/api";
import { Book } from "@/components/book";
import { Chips } from "@/components/chips";
import { usePanels } from "@/components/panel";
import { Support } from "@/components/support";
import { type Drop, useDrag } from "@/lib/drag";
import { useBoardFilter, useMobile, useRefresh } from "@/lib/hooks";
import { useResize } from "@/lib/resize";
import { viewOf } from "@/lib/views";
import { useLive } from "@/live";
import { Nav } from "@/pages/nav";
import { useAuth, useData } from "@/store";
import { useViews } from "@/views";
import { AfterContext, modals } from "./modals";
import { useTitle } from "./title";
export function Shell() {
  const $ = _c(2);
  const token = useAuth(_temp);
  if (!token) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <Navigate to={{
        pathname: "/login",
        search: location.search
      }} replace={true} />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Booklet />;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
function _temp(s) {
  return s.token;
}
function Booklet() {
  useRefresh();
  useTitle();
  useLive();
  const mobile = useMobile();
  const snapshot = useData(s => s.snapshot);
  const place = useData(s_0 => s_0.place);
  const [filter, setFilter] = useBoardFilter();
  const {
    t
  } = useTranslation();
  const token = useAuth(s_1 => s_1.token);
  // `me` comes with sign-in; a session restored without it (or renamed since) is refreshed once
  useEffect(() => {
    if (token) api.session.me(token).then(p => useAuth.setState({
      me: p
    }), () => {});
  }, [token]);
  const navigate = useNavigate();
  const pages = useViews().flatMap(v => Object.keys(v.pages ?? {}));
  const view = viewOf(useLocation().pathname, pages);
  const panels = usePanels(modals(t), mobile);
  const bookRef = useRef<HTMLElement>(null);
  const onDrop = useRef<Drop>(() => {});
  onDrop.current = (task, status, after) => void place(task, status as TaskStatus, after);
  useDrag(bookRef, onDrop);
  useResize(bookRef, !mobile);
  return <AfterContext.Provider value={panels.after}>
			<Book bookRef={bookRef} mobile={mobile} ready={!!snapshot} overlay={view === "board" && <Chips filter={filter} snapshot={snapshot} setFilter={setFilter} />}>
				<Nav snapshot={snapshot} filter={filter} settings={view === "settings"} onSettings={() => navigate(view === "settings" ? "/" : "/settings")} />
				{panels.after("nav")}
				<Outlet />
				{panels.after("end")}
			</Book>
			{panels.sheet}
			<Support />
		</AfterContext.Provider>;
}